import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MonitorInteractionItem, ReportByFilter } from '@app/models';
import * as _ from 'lodash';
import { environment } from '../../environments/environment';
@Injectable({ providedIn: 'root' })
export class MonitorInteractionItemService {
  basePath: string = `${environment.apiUrl}/monitor-interactions`;

  constructor(private http: HttpClient) {}

  findByInteraction(interactionId: number) {
    return this.http.get<MonitorInteractionItem[]>(
      `${this.basePath}/interactions/${interactionId}`
    );
  }

  saveBatch(items: MonitorInteractionItem[]) {
    return this.http.post<any>(`${this.basePath}/batch`, items);
  }
  patch(item: MonitorInteractionItem) {
    return this.http.put<any>(`${this.basePath}/${item.id}`, item);
  }

  getInteractionReport(reportByFilter: ReportByFilter) {
    // let options = { params: <any> _.omitBy(reportByFilter, _.isNil)};
    return this.http.post<any>(`${this.basePath}/report`, reportByFilter);
  }

  interactionItemReportDownload(reportByFilter: ReportByFilter, type: string) {
    let options = { responseType: 'blob' as 'json' };

    return this.http.post<any>(
      `${this.basePath}/report/download/${type}`,
      reportByFilter,
      options
    );
  }

  interactionItemReportDownloadExcel(reportByFilter: ReportByFilter) {
    let options = { responseType: 'blob' as 'json' };

    return this.http.post<any>(
      `${this.basePath}/report/download/XLSX`,
      reportByFilter,
      options
    );
  }

  interactionItemReportDownloadCSV(reportByFilter: ReportByFilter) {
    let options = { responseType: 'blob' as 'json' };

    return this.http.post<any>(
      `${this.basePath}/report/download/CSV`,
      reportByFilter,
      options
    );
  }

  distinctChecklistItems(reportByFilter: ReportByFilter) {
    let options = { params: <any>_.omitBy(reportByFilter, _.isNil) };
    return this.http.get<any>(`${this.basePath}/items`, options);
  }

  validateDeclinedAi(
    interactionId: number,
    itemId: number,
    decision: 'ACCEPT' | 'REJECT',
    explanationText: string | null,
    contestationId: number | null,
    justificationId?: number | null
  ) {
    const body: any = {
      decision,
      explanationText,
      contestationId,
    };
    
    if (justificationId) {
      body.justificationId = justificationId;
    }
    
    return this.http.patch<any>(
      `${environment.apiUrl}/interactions/${interactionId}/items/${itemId}/validate-declined-ai`,
      body
    );
  }

  // contestation(itemId:number, contestation:string){
  //   return this.http.put<any>(`${this.basePath}/${itemId}/contestation`, contestation);
  // }
}
